import { api } from "./api";

const loadScript = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => reject(new Error("Razorpay failed to load"));
    document.body.appendChild(s);
  });

/* Opens Razorpay checkout for a created booking and verifies the signature on the backend. */
export async function payWithRazorpay({ booking, keyId }) {
  await loadScript();
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: keyId,
      amount: booking.total * 100,
      currency: "INR",
      name: "OGO Hygiene Solutions",
      description: booking.service_name?.en,
      order_id: booking.razorpay_order_id,
      prefill: { name: booking.name, contact: booking.phone },
      theme: { color: "#E6C280" },
      handler: async (res) => {
        try {
          await api.post("/payments/razorpay/verify", { booking_id: booking.id, ...res });
          resolve();
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rz.open();
  });
}
